import { Flex } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { InvoicesFilter } from 'components/invoices/invoices-filter';
import { InvoicesSyncAction } from 'components/invoices/invoices-sync-action';

export const InvoicesListPageHeader = () => {
  return (
    <PageHeader
      title={
        <Flex gap='middle' align='center'>
          <InvoicesFilter />
          <InvoicesSyncAction />
        </Flex>
      }
    />
  );
};
